import {productTypes} from '../Constants/productMarkingType'

export const getProductType = (products) => {
    
    return {
        type: productTypes.GET_ALLPRODUCTS,
        payload: products
    };
};